import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { connect } from 'react-redux';

import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  indexRequest,
  worldIndexRequest,
  indexRequestSuccess,
  psIndexRequest,
  topInterestRequest,
  topVolumeRequest,
} from '../../../containers/banggia/actions';

import { setTypeIndex, setSetting } from '../../../containers/client/actions';
import { saveState } from '../../../lib/storages';

import CardChart from './layout/cardChart';
import CardInfo from './layout/cardInfo';
import CardTop from './layout/cardTop';

import {
  numberFormat,
  StringToInt,
  _getStatusIndex,
  _processMapDataIndex,
} from '../../../utils';

import {
  makeDataForeign,
  makeGetTotalGD,
  makeGetIndexList,
  makeGetSetting,
  makeGetTypeIndex,
  makeGetIndexSummary,
  makeGetReceive1101,
  makeGetPsList,
  makeGetPsIndex,
  makeGetConfig,
  makeGetTopInterest,
  makeGetTopVolume,
} from '../../../lib/selector';

import * as _ from 'lodash';

import { indSumRequest } from '../../../containers/banggia/actions';
import { translate } from 'react-i18next';

// Hook
function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

function IndexIndicator(props) {
  const [total10, setTotal10] = useState(0);
  const [total02, setTotal02] = useState(0);

  const prevReceive1101 = usePrevious(props.receive1101);
  const prevIndexList = usePrevious(props.indexList);

  const { psList, psIndexRequest, topInterest, topVolume } = props;

  useEffect(() => {
    const intervalSummary = setInterval(fetchIndexSummary, 60 * 1000);

    return () => {
      if (intervalSummary) clearInterval(intervalSummary);
    };
  }, []);

  useEffect(() => {
    if (props.config) {
      fetchIndexList();
      fetchWorldIndex();
      fetchIndexSummary();
    }
  }, [props.config]);

  useEffect(() => {
    // const _dtTest = {"id":1101.0,"mc":"10","cIndex":1155.78,"oIndex":1114.93,"vol":5.68009563E8,"value":1.3896278E7,"time":"14:50:59","status":"C","accVol":0.0,"ot":"40.85|3.66%|13896278|425|43|28"};
    if (prevIndexList !== props.indexList) {
      const _total02 = _.find(props.indexList, (o) => o.mc === '02')?.value * 1;
      const _total10 = _.find(props.indexList, (o) => o.mc === '10')?.value * 1;
      // const _total10 = _dtTest.value;
      console.log(_total10);
      setTotal02(_total02);
      setTotal10(_total10);
    }
  }, [props.indexList]);

  useEffect(() => {
    if (prevReceive1101 !== props.receive1101) {
      const { receive1101 } = props;
      if (['10', '02'].includes(receive1101.mc)) {
        if (receive1101.mc === '02') setTotal02(receive1101.value);
        if (receive1101.mc === '10') setTotal10(receive1101.value);
      }
    }
  }, [props.receive1101]);

  const fetchIndexList = () => {
    const { indexRequest } = props;
    const data = '10,11,02,03';
    return indexRequest(data);
  };

  const fetchWorldIndex = () => {
    const { worldIndexRequest } = props;
    return worldIndexRequest();
  };

  const fetchIndexSummary = () => {
    const { indSumRequest, topInterestRequest, topVolumeRequest } = props;
    indSumRequest();
    topInterestRequest();
    topVolumeRequest();
  };

  const _handleSetTypeIndex = (typeIndex) => {
    const { setTypeIndex, setting } = props;
    setTypeIndex(typeIndex);

    saveState('setting', { ...setting, typeIndex: typeIndex });
  };

  const _handleSetIndexHide = (indexCode) => {
    const { setSetting, setting } = props;
    let _setting = Object.assign({}, setting);

    let { indHid } = _setting;
    if (!indHid) indHid = [];
    indHid.push(indexCode);

    _setting.indHid = indHid;
    setSetting(_setting);

    saveState('setting', _setting);
  };

  const memoizedCallback = useCallback(
    (state) => _handleSetIndexHide(state),
    []
  );

  useEffect(() => {
    let timer;
    if (psList && psList.length) {
      psIndexRequest(psList[0] + ',' + psList[1]);

      timer = setInterval(
        () => psIndexRequest(psList[0] + ',' + psList[1]),
        10 * 1000
      );
    }

    if (new Date().getHours >= 15 || new Date().getHours < 8) return;

    return () => timer && clearInterval(timer);
  }, [props.psList]);

  const { indexList, indSum, psIndex, typeIndex, setting, t } = props;

  const { indHid } = setting;

  const summaryTrade = {
    head: t('txt-cs'),
    subHead: t('txt-all-market'),
    data: [
      {
        name: t('txt-total-transaction'),
        value:
          numberFormat(
            (StringToInt(total02) + StringToInt(total10)) / 1000,
            0
          ) +
          ' (' +
          t('txt-label-billion') +
          ')',
        cl: 'text-white',
      },
      {
        name: t('txt-total-putThrough'),
        value:
          (indSum ? numberFormat(indSum.ptvalue / 1000000, 0, '-') : '-') +
          ' (' +
          t('txt-label-billion') +
          ')',
        cl: 'text-white',
      },
      {
        name: t('txt-total-foreign'),
        value:
          (indSum ? numberFormat(indSum.frvalue / 1000000, 0, '-') : '-') +
          ' (' +
          t('txt-label-billion') +
          ')',
        cl: 'text-white',
      },
    ],
  };

  return (
    <div
      className="d-flex flex-row bt-1-half w-100"
      style={{ overflowY: 'hidden' }}
    >
      <PerfectScrollbar
        className="position-relative"
        style={{
          width: 'calc( 100% - 390px )',
          height: `${typeIndex === 2 ? '90px' : typeIndex === 3 ? '45px' : ''}`,
          marginLeft: '5px',
        }}
      >
        <div
          className="d-grid flex-row"
          style={{
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: '5px',
            minWidth: '1115px',
          }}
        >
          {indexList &&
            !!indexList.length &&
            indexList.map((idata, i) => {
              {
                /* if (indHid && indHid.indexOf(idata.mc) > -1) return null; */
              }

              return (
                <CardChart
                  key={idata.mc + i}
                  idata={idata}
                  typeIndex={typeIndex}
                  closeIndex={memoizedCallback}
                />
              );
            })}
        </div>
      </PerfectScrollbar>
      <div className="d-flex flex-row">
        <CardTop
          typeIndex={typeIndex}
          topInterest={topInterest}
          topVolume={topVolume}
        />

        {/* <CardInfo
          idata={summaryTrade}
          typeIndex={typeIndex}
          psIndex={psIndex}
        /> */}
      </div>
    </div>
  );
}

const makeMapStateToProps = () => {
  const getReceive1101 = makeGetReceive1101();
  const getDataForeign = makeDataForeign();
  // const getTotalGD = makeGetTotalGD();
  const getIndexList = makeGetIndexList();
  const getTypeIndex = makeGetTypeIndex();
  const getIndexSummary = makeGetIndexSummary();
  const getSetting = makeGetSetting();
  const getPsList = makeGetPsList();
  const getPsIndex = makeGetPsIndex();
  const getConfig = makeGetConfig();
  const getTopInterest = makeGetTopInterest();
  const getTopVolume = makeGetTopVolume();

  const mapStateToProps = (state) => {
    return {
      config: getConfig(state),
      receive1101: getReceive1101(state),
      dataForeign: getDataForeign(state),
      indexList: getIndexList(state),
      indSum: getIndexSummary(state),
      typeIndex: getTypeIndex(state),
      setting: getSetting(state),
      psList: getPsList(state),
      psIndex: getPsIndex(state),
      topInterest: getTopInterest(state),
      topVolume: getTopVolume(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  indexRequest,
  worldIndexRequest,
  indSumRequest,
  indexRequestSuccess,
  setTypeIndex,
  setSetting,
  psIndexRequest,
  topInterestRequest,
  topVolumeRequest,
})(translate('translations')(IndexIndicator));
